<div class="scanner-container">
    <zxing-scanner
      [tryHarder]="true"
      (scanSuccess)="onScanSuccess($event)">
    </zxing-scanner>
</div>